<template>
  <div>
    <div id="content-box">
      <h4>{{ $t('plexRemoved') }}</h4><br>
      <p>{{ $t('plexRemovedInfo') }}</p><br>
      <p>{{ $t('visitMethods') }}</p>
      <p>{{ $t('firstMethod') }}</p>
      <p><span>{{ $t('secondMethod') }}</span><router-link :to="currentUrl">{{ currentUrl }}</router-link></p><br>
      <p>{{ $t('suggest') }}</p>
    </div>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'ios-reach',
    computed: {
      mediaType() {
        return this.$store.state.mediaType
      },
      currentUrl() {
        return window.location.href.match(/(\S*)\//)[1]
      }
    },
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables.scss";

  #content-box {
    padding: .2rem .2rem 0 .2rem;
    margin: .55rem auto 0 auto;
    color: $gray-darker;
    max-width: 8rem;
    * {
      padding: 0;
      margin: 0;
    }
  }

  h4 {
    font-size: .2rem;
    line-height: .28rem;
    letter-spacing: 1.43px;
  }

  p {
    font-size: .14rem;
    letter-spacing: 1px;
    line-height: .2rem;
  }

  a {
    color: $base-green;
  }
</style>





// WEBPACK FOOTER //
// Index.vue?d2752afe